import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class ProductSeries extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json');
        this.setHeader('Accept', 'application/json');
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`);

    }

    static request(Callback) {
        return new ProductSeries(Callback);
    }


    createProductSeries(data) {
        return this.post('ProductSeries',data);
    }

    createBatch(data) {
        return this.post('Batch/Production-Line',data);
    }



    ProductSeriesProductionLine(id) {
        return this.get(`ProductSeries/Production-Line/${id}`);
    }

}

export default ProductSeries;
